module.exports = __webpack_public_path__ + "img/1_012.b73d2b67.jpg";